var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H3a2 2 0 01-2-2V3a2 2 0 012-2h4m7 14l5-5m0 0l-5-5m5 5H7",
    stroke: "#73A3BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTlIM0MyLjQ2OTU3IDE5IDEuOTYwODYgMTguNzg5MyAxLjU4NTc5IDE4LjQxNDJDMS4yMTA3MSAxOC4wMzkxIDEgMTcuNTMwNCAxIDE3VjNDMSAyLjQ2OTU3IDEuMjEwNzEgMS45NjA4NiAxLjU4NTc5IDEuNTg1NzlDMS45NjA4NiAxLjIxMDcxIDIuNDY5NTcgMSAzIDFIN00xNCAxNUwxOSAxME0xOSAxMEwxNCA1TTE5IDEwSDciIHN0cm9rZT0iIzczQTNCQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgLogout as ReactComponent };